import { render, staticRenderFns } from "./sellerAdd.vue?vue&type=template&id=3763c172&scoped=true&"
import script from "./sellerAdd.vue?vue&type=script&lang=js&"
export * from "./sellerAdd.vue?vue&type=script&lang=js&"
import style0 from "./sellerAdd.vue?vue&type=style&index=0&id=3763c172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763c172",
  null
  
)

export default component.exports